<script>
  export let title;
  export let big = false;
</script>

{#if big}
    <h1>{title}</h1>
{:else}
    <h2>{title}</h2>
{/if}

<slot></slot>
<br>
<br>
